import Avatar from '@atlaskit/avatar';
import { useInfo } from '../../../../../components/Flow/ConsentContextProvider';

const Logo = () => {
  const { client } = useInfo();
  return <Avatar src={client?.appLogoUrl} size="xxlarge" />;
};

export default Logo;
